import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// img
import FooterLogoDark from "../../images/logo-dark.png";

export default function Footer() {
    return (
        <>
            <footer className='footer-section section-light'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col md={10} lg={8} xl={3}>
                            <div className='text-center text-xl-start mb-5 mb-xl-0'>
                                <img src={FooterLogoDark} alt="" className='' height={36} />
                                <p className='text-muted fs-15 mt-3'>Nemo has ipsam voluptatem as voluptas sit aspernatur odit aut fugit sed consequuntur magni dolores eos qui ratione.</p>
                                <h5 className='fw-semibold'>Follow Us</h5>
                                <ul className='list-inline footer-icon-content'>
                                    <li className='list-inline-item'><Link to="/" className='footer-icon icon-hover-primary'><i className="bi bi-facebook"></i></Link></li>
                                    <li className='list-inline-item'><Link to="/" className='footer-icon icon-hover-danger'><i className="bi bi-instagram"></i></Link></li>
                                    <li className='list-inline-item'><Link to="/" className='footer-icon icon-hover-dark'><i className="bi bi-threads"></i></Link></li>
                                    <li className='list-inline-item'><Link to="/" className='footer-icon icon-hover-info'><i className="bi bi-slack"></i></Link></li>
                                    <li className='list-inline-item'><Link to="/" className='footer-icon icon-hover-success'><i className="bi bi-whatsapp"></i></Link></li>
                                </ul>
                            </div>
                        </Col>
                        <Col xl={{ span: 8, offset: 1 }}>
                            <Row>
                                <Col sm={6} md={4}>
                                    <h5>About Us</h5>
                                    <div className='footer-links'>
                                        <Link to="/" className='footer-link'>How It Work</Link>
                                        <Link to="/" className='footer-link'>Customers</Link>
                                        <Link to="/" className='footer-link'>Our Story</Link>
                                        <Link to="/" className='footer-link'>Career</Link>
                                        <Link to="/" className='footer-link'>Contact Us</Link>
                                        <Link to="/" className='footer-link'>FAQs</Link>
                                    </div>
                                </Col>
                                <Col sm={6} md={4}>
                                    <h5 className='mt-4 mt-sm-0'>Support & Summary</h5>
                                    <div className='footer-links'>
                                        <Link to="/" className='footer-link'>Question</Link>
                                        <Link to="/" className='footer-link'>Helping Center</Link>
                                        <Link to="/" className='footer-link'>Privacy & Policy</Link>
                                        <Link to="/" className='footer-link'>Buy or Rent</Link>
                                        <Link to="/" className='footer-link'>Properties</Link>
                                        <Link to="/" className='footer-link'>Blogs</Link>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className='mt-4 mt-md-0'>
                                        <h5>Contact Us</h5>
                                        <div className="d-flex aling-item-center footer-contact-us">
                                            <div className="flex-shrink-0">
                                                <div className='avatar avatar-sm bg-soft-primary text-primary rounded-circle'><i className="bi bi-envelope fs-20"></i></div>
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h6 className='mb-0'>E-mail</h6>
                                                <Link to="/" className='text-muted fs-15'>youremailid@gmail.com</Link>
                                            </div>
                                        </div>
                                        <div className="d-flex aling-item-center footer-contact-us">
                                            <div className="flex-shrink-0">
                                                <div className='avatar avatar-sm bg-soft-primary text-primary rounded-circle'><i className="bi bi-telephone fs-20"></i></div>
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h6 className='mb-0'>Contact</h6>
                                                <Link to="/" className='text-muted fs-15'>(+01) 123 456 7890</Link>
                                            </div>
                                        </div>
                                        <div className="d-flex aling-item-center footer-contact-us">
                                            <div className="flex-shrink-0">
                                                <div className='avatar avatar-sm bg-soft-primary text-primary rounded-circle'><i className="bi bi-pin-map fs-20"></i></div>
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h6 className='mb-0'>Location</h6>
                                                <Link to="/" className='text-muted fs-15'>3012 Pine Garden Lane Atlanta, Boulevard, GA 30328</Link>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <hr className='mt-md-5 mb-4' />
                    <Row>
                        <Col md={12}>
                            <div className='d-md-flex justify-content-md-between text-center text-md-start'>
                                <p className='mb-2 mb-md-0 text-muted'>Copyright © {(new Date().getFullYear())} <Link to="https://felgundesign.com" target="_blank">Felgun Design</Link>. Crafted with <i className="bi bi-heart-fill text-danger"></i></p>
                                <Link to="/" className='text-muted'>Term Condition & Policy</Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </>
    )
}
